module.exports = __webpack_public_path__ + "static/media/Rudelabel.b51be70b.jpg";